"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

require("core-js/modules/es.array.is-array.js");

require("core-js/modules/es.date.to-string.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.replace.js");

require("core-js/modules/es.string.trim.js");

require("core-js/modules/es.string.split.js");

/**
 * @function Validate[required] - 验证表单里的值是否存在
 * @desc 验证是否有值，ps: 因为不同类型对“有值”的定义不同，需分类型校验，常用于表单的验证
 * @param {any} value
 * @return {boolean} true/false
 */
var required = function required(value) {
  try {
    if (Array.isArray(value)) return !!value.length;
    if (value === undefined || value === null) return false;
    if (value instanceof Date) return !isNaN(value.getTime());

    if ((0, _typeof2["default"])(value) === "object") {
      for (var i in value) {
        return true;
      }

      return false;
    }

    return !!String(value).length;
  } catch (err) {
    console.warn(err);
    return false;
  }
};
/**
 * @function Validate[validatePhone] - 验证手机号
 * @param {string | number} phone 手机号
 * @return {boolean} true/false
 * @example
 * import { Validate } from '@zz-biz/utils';
 *
 * Validate.validatePhone(13552002345)
 * // true
 * Validate.validatePhone(1122)
 * // false
 */


var validatePhone = function validatePhone(phone) {
  try {
    return /^1(\d){10}$/.test(phone);
  } catch (err) {
    console.warn(err);
    return false;
  }
};
/**
 * @function Validate[validateIdCard] - 验证身份证号
 * @param {string} idCard 身份证号
 * @return {boolean} true/false
 * @example
 * import { Validate } from '@zz-biz/utils';
 * Validate.validateIdCard('544223189809030453');
 * // true
 */


var validateIdCard = function () {
  var Wi = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2, 1]; // 加权因子

  var ValideCode = [1, 0, 10, 9, 8, 7, 6, 5, 4, 3, 2]; // 身份证验证位值.10代表X

  return function (idCard) {
    try {
      idCard = idCard.trim().replace(/ /g, ""); //去掉字符串头尾空格

      idCard = idCard.split(""); //分隔得到身份证数组

      if (idCard.length == 18) {
        var sum = 0;

        if (idCard[17].toLowerCase() == "x") {
          idCard[17] = 10; // 将最后位为x的验证码替换为10方便后续操作
        }

        for (var i = 0; i < 17; i++) {
          sum += Wi[i] * idCard[i]; // 加权求和
        }

        var valCodePosition = sum % 11; // 得到验证码所位置

        if (idCard[17] == ValideCode[valCodePosition]) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    } catch (err) {
      console.warn(err);
      return false;
    }
  };
}();
/**
 * @function Validate[url] - 校验有效的url地址
 * @param {string} val url地址
 * @return {boolean} true/false
 * @example
 * import { Validate } from '@zz-biz/utils';
 *
 * Validate.url('https://pic.zhuanzhuan.com/ussd/aasdfsdfdss.png')
 * // true
 * Validate.url(1122)
 * // false
 */


var url = function url(val) {
  return typeof val === 'string' && /(https?|ftp|file):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/.test(val);
};
/**
 * @function Validate[src] - 校验有效的图片地址
 * @param {string} val 图片地址
 * @return {boolean} true/false
 * @example
 * import { Validate } from '@zz-biz/utils';
 *
 * Validate.src('https://pic.zhuanzhuan.com/ussd/aasdfsdfdss.png')
 * // true
 * Validate.src(1122)
 * // false
 */


var src = function src(val) {
  return typeof val === 'string' && /^(https?:)?\/\/|data:image|\.(jpg|png|jpeg|gif|webp|bmp)$/i.test(val);
};
/**
 * @function Validate[bankCard] - 校验有效的银行卡
 * @param {string} val 银行卡
 * @return {boolean} true/false
 * @example
 * import { Validate } from '@zz-biz/utils';
 *
 * Validate.bankCard('62288888888888888')
 * // true
 * Validate.bankCard(1122)
 * // false
 */


var bankCard = function bankCard(val) {
  return typeof val === 'string' && /^\d{16,19}$/.test(val);
};
/**
 * @function Validate[email] - 校验邮箱
 * @param {string} val 邮箱
 * @return {boolean} true/false
 * @example
 * import { Validate } from '@zz-biz/utils';
 *
 * Validate.email('yuanxiaolddssdd@zhuanzhuan.com')
 * // true
 * Validate.email('zhuanzhuan@test')
 * // false
 */


var email = function email(val) {
  return typeof val === 'string' && /^[a-z0-9_-]+@[a-z0-9_-]+(\.[a-z0-9_-]+)+$/i.test(val);
};

var _default = {
  required: required,
  validatePhone: validatePhone,
  validateIdCard: validateIdCard,
  src: src,
  url: url,
  bankCard: bankCard,
  email: email
};
exports["default"] = _default;